import React from "react";
import hero from "../../../assets/img/Hero.jpeg";
import { NavLink } from "react-router-dom";
import gradient from "../../../assets/img/Gradient.png";

const Hero = () => {
	return (
		<section
			className='bg-cover bg-center bg-fixed h-full'
			style={{
				backgroundImage: `url(${hero})`,
			}}>
			<div className='bg-black/50 flex items-center justify-center'>
				<div className='text-center text-white max-w-[1440px] mx-auto w-[90%] md:pt-52 pt-40 pb-16'>
					<h1 className=' lg:font-medium font-semibold lg:tracking-[-3px] tracking-[-1px] text-white mb-4'>
						<span className='xl:text-[120px]/[132px] lg:text-[80px]/[100px] text-[40px]/[44px]'>
							Making Healthcare Accessible
						</span>
						<span
							className='bg-contain max-h-[124px] h-[124px] px-6 xl:text-[120px]/[124px] lg:text-[80px]/[100px] text-[40px]/[44px]'
							style={{
								backgroundImage: `url(${gradient})`,
								backgroundSize: 'contain'
							}}>
							for All{" "}
							{/* <img src={gradient} alt='' className='absolute top-10 left-0' /> */}
						</span>
					</h1>

					{/* Description */}
					<p className='w-full lg:w-2/3 text-center text-base/5 lg:text-lg/7 font-light mb-8 mx-auto'>
						We are dedicated to creating pathways to healthcare for middle-class
						and under-served populations. By connecting patients and providers,
						we are making a tangible difference in communities that need it the
						most.
					</p>

					{/* Buttons */}
					<nav className='flex sm:flex-row flex-col justify-center sm:gap-6 gap-4'>
						{/* Get Started Button */}
						<NavLink
							to='/get-started'
							className='bg-[#1bb96a] text-black md:px-[69px] px-10 py-4 lg:rounded-[67px] rounded-[37px] font-medium hover:bg-[#45E99E] hover:text-white transition duration-300 lg:text-lg/7 '>
							Get Started
						</NavLink>
						{/* Get Involved Button */}
						<NavLink
							to='/get-involved'
							className='bg-transparent text-[#1bb96a] border border-[#1bb96a] md:px-[69px] px-10 py-4 lg:rounded-[67px] rounded-[37px] font-medium hover:bg-[#1bb96a] hover:text-white transition duration-300 md:lg:text-lg/7'>
							Get Involved
						</NavLink>
					</nav>
				</div>
			</div>
		</section>
	);
};

export default Hero;
